FormData.prototype.appendRecursive = function(data, wrapper) {
  for(let x in data) {
    if(typeof data[x] == 'object' || data[x]?.constructor === Array) {
      this.appendRecursive(data[x], (wrapper ? wrapper + '[' + x + ']' : x));
    } else {
      this.append((wrapper ? wrapper + '[' + x + ']' : x), data[x]);
    }
  }
}
